export const NetworkContextName = "NETWORK";
export const ACTIVE_NETWORK = 97;
export const RPC_URL = "https://data-seed-prebsc-1-s3.binance.org:8545/";

export const plotNFTContractAddress =
  "0xa7fFA873CC7f05334AffF448e959FD3eC42A417C";
export const buildingNFTContractAddress =
  "0xa90cA94e32E71334FFF0C2BA7883027e6c284368";
export const unityURL = "https://educationmetaverse.mobiloitte.com/";
